@import '../../vars.css';

.input {
    color: var(--input-color);
    caret-color: var(--input-caret-color);
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.input:-webkit-autofill {
    -webkit-text-fill-color: var(--input-color);
}

.input::placeholder {
    color: var(--input-placeholder-color);
}

.hasInnerLabel::placeholder {
    color: var(--input-with-label-placeholder-color);
}

/* READ-ONLY STATE */

.input:read-only:not(.disableUserInput) {
    color: var(--input-read-only-color);
    -webkit-text-fill-color: var(--input-read-only-color);

    &:focus::placeholder {
        color: var(--input-placeholder-color);
    }
}

/* DISABLED STATE */

.input:disabled {
    color: var(--input-disabled-color);
    -webkit-text-fill-color: var(--input-disabled-color);
}

/* FOCUS STATE */

.input:focus::placeholder {
    color: var(--input-focus-placeholder-color);
}

/* ERROR STATE */
.error {
    color: var(--input-error-color);
    caret-color: var(--input-error-color);
}
